import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/esg/esgTen/img1.webp";
import img2 from "../../../assets/img/esg/esgTen/img2.webp";
import arrow from "../../../assets/img/esg/esgTen/arrow2.webp";

import iso1 from "../../../assets/img/home/certifications/card1.webp";
import iso2 from "../../../assets/img/home/certifications/card3.webp";
import iso3 from "../../../assets/img/home/certifications/card4.webp";
import iso4 from "../../../assets/img/home/certifications/card5.webp";

function EsgTen() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={400}>
      <div id="esgTen" className={`esgTen ${isVisible ? "visible" : ""}`}>
        <div className="esgTenLogo">
          <img
            src={img1}
            alt=""
            className={`img gheco ${isVisible ? "visible" : ""}`}
          />
          <img
            src={img2}
            alt=""
            className={`img gheco ${isVisible ? "visible" : ""}`}
          />
          <div className="links">
            <a
              href="#esgTwelve"
              reloadDocument
              className={`link5 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" width={"40px"} />
              <p>{t("esg_ten_link1")}</p>
            </a>
            <a
              href="#esgFive"
              reloadDocument
              className={`link2 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" width={"40px"} />
              <p>{t("esg_ten_link2")}</p>
            </a>
            <a
              href="#esgSix"
              reloadDocument
              className={`link5 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" width={"40px"} />
              <p>{t("esg_ten_link3")}</p>
            </a>
            <a
              href="#esgFour"
              reloadDocument
              className={`link3 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" width={"40px"} />
              <p>{t("esg_ten_link4")}</p>
            </a>
            <a
              href="#esgFour"
              reloadDocument
              className={`link4 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" width={"40px"} />
              <p>{t("esg_ten_link5")}</p>
            </a>
            <a
              href="#esgFour"
              reloadDocument
              className={`link5 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" width={"40px"} />
              <p>{t("esg_ten_link6")}</p>
            </a>
          </div>
        </div>
        <div className="esgTenText">
          {/* <div className="gheco">
              <h1 className={`${isVisible ? 'visible' : ''}`}>GH<span>Eco</span></h1>
            </div> */}
          <div className="politica">
            <h2 className={`${isVisible ? "visible" : ""}`}>
              {t("esg_ten_h2")}
            </h2>
            <p className={`${isVisible ? "visible" : ""}`}>
              {t("esg_ten_text")}
            </p>
          </div>
        </div>
      </div>
    </VisibilitySensor>
  );
}
export default EsgTen;
